import { NgModule, ApplicationRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { SharedcoreModule } from './sharedcore.module';
import { SharedModule } from './shared.module';
import { AppComponent } from './app.component';
import { NavigationLayoutComponent } from './layout/navigation.component';

// Authentication
import { HomeComponent } from './home/home.component';
import { routing } from './app.routing';

// Services
import { UserService } from './shared/services/user.service';
import { AuthService } from './shared/services/auth.service';
import { AuthGuard } from './shared/auth.guard';
import { ArtistSearchService } from './shared/services/artist-search.service';

// Thirs party Modules
import { ApolloModule } from 'apollo-angular';
import { provideClients } from './graphql.client';
import { removeNgStyles, createNewHosts } from '@angularclass/hmr';
import { WindowRefService } from './shared/services/window-ref.service';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    SharedModule,
    SharedcoreModule,
    routing,
    ApolloModule.forRoot(provideClients),
    CommonModule,
    // IonicModule.forRoot(AppComponent)
  ],
  declarations: [
    AppComponent,
    NavigationLayoutComponent,
    HomeComponent
  ],
  providers: [
    UserService, AuthService, AuthGuard, ArtistSearchService, WindowRefService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(public appRef: ApplicationRef) {}
  hmrOnInit(store) {
    console.log('HMR store', store);
  }
  hmrOnDestroy(store) {
    let cmpLocation = this.appRef.components.map(cmp => cmp.location.nativeElement);
    // recreate elements
    store.disposeOldHosts = createNewHosts(cmpLocation);
    // remove styles
    removeNgStyles();
  }
  hmrAfterDestroy(store) {
    // display new elements
    store.disposeOldHosts();
    delete store.disposeOldHosts;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/app.module.ts